/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService
 */

/**
 *  Summary view of a Custom Copilot for list responses
 *  Contains essential information without heavy details like full resource configurations
 */

/**
 *  Represents a Knowledge Box with complete information (ID + metadata)
 *  Initially may contain only the ID, but can be hydrated with name and description
 */

/**
 *  Request to create a new portal-specific copilot.
 */

/**
 *  Response for creating a new portal-specific copilot.
 */

/**
 *  Request to delete an existing portal copilot
 */

/**
 *  Response after deleting a portal copilot
 */

/**
 *  Request to duplicate an existing portal copilot.
 */

/**
 *  Response from duplicating a portal copilot.
 */

/**
 *  Request to get a copilot by ID
 */

/**
 *  Response for getting an existing portal-specific copilot.
 */

/**
 *  Request for listing copilots with only essential information.
 *  This is a simplified version of {@link ListCopilotsRequest} that returns
 *  minimal copilot data for fast list operations.
 */

/**
 *  Response for listing copilots with only essential information.
 *  This is a simplified version of {@link ListCopilotsResponse} that returns
 *  minimal copilot data for fast list operations.
 */

/**
 *  Response containing a list of copilots with RPC-friendly format
 */

/**
 *  Request to update an existing portal copilot
 */

/**
 *  Response after updating a portal copilot
 */

export const createPortalCopilotRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'createPortalCopilot',
  auth: 'app',
  fingerprint: 'wB3o2_zdPHdt3-o0OD5rHQ273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const duplicatePortalCopilotRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'duplicatePortalCopilot',
  auth: 'app',
  fingerprint: 'qZnpPqO2y8pD2-nUq0RDDg273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePortalCopilotRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'updatePortalCopilot',
  auth: 'app',
  fingerprint: 'Woaev5E4ppJYc7WgQdvv8g273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePortalCopilotRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'deletePortalCopilot',
  auth: 'app',
  fingerprint: 'LzuvGcX8jjKN1ozjo3p2hQ273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCopilotsRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'listCopilots',
  auth: 'app',
  fingerprint: 's2B8zyCi5CO32UyKUd4iNw273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCopilotsSummariesRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'listCopilotsSummaries',
  auth: 'app',
  fingerprint: 'XErvpNJ5Glz_PiAgc3tjJg273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCopilotRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCustomCopilotsService',
  rpcName: 'getCopilot',
  auth: 'app',
  fingerprint: 'sP6-NMTOWAx2Xu31t1ezxQ273x9VM4ej',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};